import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("descripcion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.descripcion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },
     
        filterDescripcion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                descripcion: val
            });
        },
        //-------------------------------------
        recargar() {
            this.form = {}
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                descripcion: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/tipo_permiso/mixins/filtros.js